import { ApiProperty, ApiPropertyOptional } from '@nestjs/swagger';
import { Expose } from 'class-transformer';
import {
  IsEnum,
  IsNotEmpty,
  IsObject,
  IsOptional,
  IsString,
  Matches,
  MaxLength,
} from 'class-validator';
import { JobRepairPhotoTypeEnum } from '../enums/job-repair-photo-type.enum';
import { PhotoMetaDataInterface } from '../../photo/interfaces/photo-meta-data.interface';

/** Bare S3 object key: no path separators, no URL. */
export const PHOTO_FILE_NAME_PATTERN = /^[\w.\-()@ ]+$/;
export const PHOTO_BATCH_MAX_ITEMS = 30;

/**
 * One photo already uploaded to S3, to be recorded against a repair. Used by
 * POST /job-repair (photos[]), PATCH /job-repair/:id/edit-batch and
 * POST /job-repair-photo/batch.
 */
export class JobRepairPhotoItemDto {
  @ApiProperty({ description: 'S3 object key returned by /uploads/sign' })
  @Expose()
  @IsNotEmpty()
  @IsString()
  @MaxLength(255)
  @Matches(PHOTO_FILE_NAME_PATTERN, {
    message: 'fileName must be a bare object key (no slashes or URL)',
  })
  fileName!: string;

  @ApiProperty({ enum: JobRepairPhotoTypeEnum })
  @Expose()
  @IsEnum(JobRepairPhotoTypeEnum)
  repairPhotoType!: JobRepairPhotoTypeEnum;

  @ApiPropertyOptional({ type: 'object' })
  @Expose()
  @IsOptional()
  @IsObject()
  metaData?: PhotoMetaDataInterface;
}

/** One photo already uploaded to S3, for the phase and bump photo batches. */
export class PhotoItemDto {
  @ApiProperty({ description: 'S3 object key returned by /uploads/sign' })
  @Expose()
  @IsNotEmpty()
  @IsString()
  @MaxLength(255)
  @Matches(PHOTO_FILE_NAME_PATTERN, {
    message: 'fileName must be a bare object key (no slashes or URL)',
  })
  fileName!: string;

  @ApiPropertyOptional({ type: 'object' })
  @Expose()
  @IsOptional()
  @IsObject()
  metaData?: PhotoMetaDataInterface;
}
